var CASA_FEATURES;
(function (CASA_FEATURES) {
    CASA_FEATURES["SGT_CASA"] = "SGT_CASA";
    CASA_FEATURES["VT_CASA"] = "VT_CASA";
    CASA_FEATURES["WIDGET_CASA"] = "Widget_CASA";
})(CASA_FEATURES || (CASA_FEATURES = {}));
var CASA_CONTEXT_STATUS;
(function (CASA_CONTEXT_STATUS) {
    CASA_CONTEXT_STATUS["PENDING"] = "pending";
    CASA_CONTEXT_STATUS["PROCESSING"] = "processing";
    CASA_CONTEXT_STATUS["READY"] = "ready";
    CASA_CONTEXT_STATUS["FAILED"] = "failed";
})(CASA_CONTEXT_STATUS || (CASA_CONTEXT_STATUS = {}));

export { CASA_CONTEXT_STATUS, CASA_FEATURES };
